import { useSearchParams } from "react-router-dom";
import { ReportList } from "./ReportList";
import { EBookList } from "./EBookList";
const PUBLICATION_TABS = [
  {
    tabIndex: 0,
    tabId: "ebook",
    tabName: "Ebook",
  },
  {
    tabIndex: 1,
    tabId: "report",
    tabName: "Report",
  },
];

const PublicationsFramework = (): JSX.Element => {
  const [searchParams, setSearchParams] = useSearchParams({ tabIndex: "0" });

  const handleTabChange = (tabId: number) => {
    setSearchParams((params) => {
      params.set("tabIndex", JSON.stringify(tabId));
      return params;
    });
  };
  const tabIndex = searchParams.get("tabIndex");
  const parsedTabIndex = tabIndex ? JSON.parse(tabIndex) : 0;

  return (
    <div className="main-container podcasts">
      <div className="podcasts-tab">
        {PUBLICATION_TABS.map((tab) => {
          const { tabIndex, tabId, tabName } = tab;

          return (
            <div
              key={tabId}
              className={`item ${tabIndex === parsedTabIndex ? "active" : ""}`}
              onClick={() => handleTabChange(tabIndex)}
            >
              {tabName}
            </div>
          );
        })}
      </div>
      <>{parsedTabIndex === 0 && <EBookList />}</>
      <>{parsedTabIndex === 1 && <ReportList />}</>
    </div>
  );
};

export default PublicationsFramework;
